/**
 * Formatação de datas/durações para exibição (pt-BR).
 * Fonte única — substitui as cópias que existiam espalhadas em hooks e componentes.
 */

export type DateStyle = 'numeric' | 'short' | 'long';

/**
 * Formata uma data ('YYYY-MM-DD' ou ISO) para pt-BR. Retorna '' se vazia.
 *
 * @param style 'numeric' → 25/12/2026 · 'short' → 25 de dez. de 2026 · 'long' → 25 de dezembro de 2026
 */
export function formatDate(
  value: string | null | undefined,
  style: DateStyle = 'numeric'
): string {
  if (!value) return '';
  const [year, month, day] = value.split('T')[0].split('-').map(Number);

  if (style === 'numeric') {
    const dd = String(day).padStart(2, '0');
    const mm = String(month).padStart(2, '0');
    return `${dd}/${mm}/${year}`;
  }

  return new Date(year, month - 1, day).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: style === 'long' ? 'long' : 'short',
    year: 'numeric',
  });
}

/** Formata uma duração em segundos como "Xmin Ys" / "Xmin" / "Ys". Retorna null se <= 0. */
export function formatDuration(seconds: number | null | undefined): string | null {
  if (!seconds || seconds <= 0) return null;
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  if (m === 0) return `${s}s`;
  if (s === 0) return `${m}min`;
  return `${m}min ${s}s`;
}
